module.exports = __webpack_public_path__ + "static/media/Banner-webshoppers-plus2020.12f9ec51.jpg";